export function uniqueBy<T>(array: T[], keyFn: (item: T) => any): T[] {
  if (!Array.isArray(array)) {
    return []
  }

  return [...new Map(array.map((item) => [keyFn(item), item])).values()]
}
